var DealsGTMHelper;

module.exports = DealsGTMHelper = {
  update: function(params) {
    var category2, category3, dlUpdate;
    category2 = params.category2, category3 = params.category3;
    if (window.dataLayer != null) {
      dlUpdate = {
        event: 'cat-nav'
      };
      window.dataLayer.push(['dl_categories.splice', 1, 2]);
      dlUpdate.dl_category_sub = category2 || '';
      if (category2 != null) {
        window.dataLayer.push(['dl_categories.push', category2]);
      }
      if (category3 != null) {
        window.dataLayer.push(['dl_categories.push', category3]);
      }
      return window.dataLayer.push(dlUpdate);
    }
  }
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWJzaGFybWEvbmFwaXN0cmFuby9idWlsZC8xNDg2Njc1NjI0Mjc0LTc0Mzcvc3RhZ2luZy1wZXJmLTIwMTcuMDIuMDlfMDAuMzUvZ29vZHMvbW9kdWxlcy9kZWFscy9mcm9udGVuZC9oZWxwZXJzL2d0bS11cGRhdGUuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUvYWJzaGFybWEvbmFwaXN0cmFuby9idWlsZC8xNDg2Njc1NjI0Mjc0LTc0Mzcvc3RhZ2luZy1wZXJmLTIwMTcuMDIuMDlfMDAuMzUvZ29vZHMvbW9kdWxlcy9kZWFscy9mcm9udGVuZC9oZWxwZXJzL2d0bS11cGRhdGUuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUE7O0FBQUEsTUFBTSxDQUFDLE9BQVAsR0FBaUIsY0FBQSxHQUFpQjtFQUFBLE1BQUEsRUFBUSxTQUFDLE1BQUQ7QUFDeEMsUUFBQTtJQUFDLDRCQUFELEVBQVk7SUFDWixJQUFHLHdCQUFIO01BQ0UsUUFBQSxHQUNFO1FBQUEsS0FBQSxFQUFPLFNBQVA7O01BRUYsTUFBTSxDQUFDLFNBQVMsQ0FBQyxJQUFqQixDQUFzQixDQUFDLHNCQUFELEVBQXlCLENBQXpCLEVBQTRCLENBQTVCLENBQXRCO01BQ0EsUUFBUSxDQUFDLGVBQVQsR0FBMkIsU0FBQSxJQUFhO01BRXhDLElBQUcsaUJBQUg7UUFDRSxNQUFNLENBQUMsU0FBUyxDQUFDLElBQWpCLENBQXNCLENBQUMsb0JBQUQsRUFBdUIsU0FBdkIsQ0FBdEIsRUFERjs7TUFHQSxJQUFHLGlCQUFIO1FBQ0UsTUFBTSxDQUFDLFNBQVMsQ0FBQyxJQUFqQixDQUFzQixDQUFDLG9CQUFELEVBQXVCLFNBQXZCLENBQXRCLEVBREY7O2FBR0EsTUFBTSxDQUFDLFNBQVMsQ0FBQyxJQUFqQixDQUFzQixRQUF0QixFQWJGOztFQUZ3QyxDQUFSIn0=
